import { render, staticRenderFns } from "./RattachmentObjects.vue?vue&type=template&id=66333f58"
import script from "./RattachmentObjects.vue?vue&type=script&lang=js"
export * from "./RattachmentObjects.vue?vue&type=script&lang=js"
import style0 from "./RattachmentObjects.vue?vue&type=style&index=0&id=66333f58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports